
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle } from 'lucide-react';

const BrokerageCostSavings = () => {
  const costSavings = [
    "Get the best cost per megabit",
    "Keep ownership of your contracts",
    "Avoid \"gotcha\" clauses in bulk commits",
    "Connect directly to the providers you trust"
  ];

  return (
    <section className="py-16 bg-white section-drift">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Real Cost Savings. Real Infrastructure Strategy.
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Instead of bloated commission padding, we help you:
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {costSavings.map((saving, index) => (
            <Card key={index} className="text-center border-nexx-green/20 hover:border-nexx-green/40 transition-colors">
              <CardContent className="p-6">
                <div className="w-12 h-12 bg-nexx-green/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="h-6 w-6 text-nexx-green" />
                </div>
                <p className="font-semibold text-gray-900">{saving}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrokerageCostSavings;
